// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CalenderSimpleSvg from '../icons/time/CalenderSimple';
var CalenderSimple = createSvgIcon({
    as: CalenderSimpleSvg,
    ariaLabel: 'calender simple',
    category: 'time',
    displayName: 'CalenderSimple'
});
export default CalenderSimple;
